
import { Injectable } from '@angular/core';
import { Observable, Subject, defer, retry, tap, timer } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { DiscussionMaster_WS_Connect } from 'src/app/GlobalVariable';

@Injectable({
    providedIn: 'root'
})
export class DiscussionListService {
    private socket$?: WebSocketSubject<any>;
    private readonly messagesSubject = new Subject<any>();
    public readonly messages$ = this.messagesSubject.asObservable();

    connect(userId: number, pageNo: number, pageSize: number): Observable<any> {
        this.close();

        const url = `${DiscussionMaster_WS_Connect}/${userId}/${pageNo}/${pageSize}`;

        return defer(() => {
            const socket = webSocket<any>(url);
            this.socket$ = socket;

            return socket.pipe(
                tap(message => this.messagesSubject.next(message))
            );
        }).pipe(
            retry({
                count: 5,
                delay: (_error, retryCount) => {
                    return timer(Math.min(1000 * retryCount, 10000));
                },
                resetOnSuccess: true
            })
        );
    }

    close(): void {
        const socket = this.socket$;
        this.socket$ = undefined;

        if (socket && !socket.closed) {
            socket.complete();
        }
    }
}
